const class_merch = {
  //
}

export default class_merch
